import { Controller, useFormContext } from 'react-hook-form'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { fieldOptions } from 'modules/expenses/hooks/useExpensesCustomization'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, { WithFieldPermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

const FIELD_NAME = 'paymentMethod'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  selectedPayment: string
  isAutomaticExpensable?: boolean
}

const PaymentMethodField = ({
  isFieldMandatory,
  customizationFields,
  selectedPayment,
  isAutomaticExpensable = false,
  isFieldReadOnly,
}: Props) => {
  const {
    control,
    getValues,
    formState: { errors },
  } = useFormContext()

  const isManual = getValues('creationType') === 'manual'

  const paymentMethodOptions = fieldOptions('expense', 'payment_method', customizationFields)
    .filter((option) => option.parent_id === selectedPayment && (!option.hidden || !isManual))
    .map((option) => ({ label: option.label, value: option.id }))

  const isReadOnly = isFieldReadOnly || isAutomaticExpensable

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <SelectField
          label={i18n.t('expenses_v2.forms.fields.payment_method.label')}
          mandatory={isFieldMandatory}
          none={i18n.t('expenses_v2.forms.fields.payment_method.placeholder')}
          options={paymentMethodOptions}
          value={field.value}
          onChange={(value) => field.onChange(value)}
          error={castError(errors?.paymentMethod)}
          readonly={isReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(PaymentMethodField, FIELD_NAME))
